<template>
    <llc-community-card
        :llc-community-card-data="activeAsset"
        :disable-carousel="disableCarousel"
        class="w-full hidden lg:block"
    />
    <llc-community-card-mobile
        :llc-community-card-data="activeAsset"
        :disable-carousel="disableCarousel"
        class="w-full lg:hidden"
    />
    <stockland-button
        additional-icon-classes="!fill-black md:!fill-white"
        additional-button-classes="absolute right-0 top-0 block p-3"
        :is-visible="true"
        :is-loading="false"
        type="button"
        layout="icon-only"
        variant="style-6"
        size="medium"
        icon="xmark"
        @button-clicked="(handleCloseCard)"
    />
</template>

<script lang="ts">
import { defineComponent, PropType } from 'vue';

import { Asset, LlcMpcMapCardsProperties } from './interfaces';

export default defineComponent({
    name: 'llc-mpc-map-llc-community-cards',
    props: {
        disableCarousel: {
            type: Boolean,
            required: false,
        },
        activeAsset: {
            type: Object as PropType<Asset>,
            required: true,
        },
    },
    emits: ['closeCard'],
    setup(props: LlcMpcMapCardsProperties, context) {
        const handleCloseCard = () => {
            context.emit('closeCard');

        }
        return {
            handleCloseCard,
            ...props
        };
    },
});
</script>
<style lang="postcss"></style>
